const baseRoute = '/coupon'

export const CouponAreaRoutes = {
  route: baseRoute,
  List: { url: baseRoute },
  Create: { url: `${baseRoute}/create` },
}
